


























import {Component, Prop, Watch} from "vue-property-decorator";
import bus from "@/main";
import {Api} from "@/core/services/MedicaPro/Api";
import {Medicine} from "@/core/services/MedicaPro/models";
import BaseComponent from "@/core/components/BaseComponent";
@Component({
    components: {}
})
export default class MedicineItemEdit extends BaseComponent {

    @Prop() itemId?: number;
    public item?: any;
    public dialog = false;
    public valid = false;
    public rules = {
        name: [(v: any) => !!v || 'Name is required'],
    }

    public mounted() {
        this.loadItem();
    }

    public save() {
        if(this.valid) {
            const API = this.item?.exists() ? Api.medicines().patchById(this.itemId!) : Api.medicines().post();
            API.save(this.item!, item => {
                this.dialog = false;
                this.$toast(`Medicin ${item.name} gemt`, {
                    color: 'green',
                    dismissable: true
                })
                bus.$emit('medicineSaved', item);
            });
        }
    }

    @Watch('itemId')
    private loadItem() {
        if(this.itemId == null) {
            // Ignore
        } else if(this.itemId == 0) {
            this.item = new Medicine();
            this.dialog = true;
        } else if(this.itemId > 0) {
            Api.medicines().getById(this.itemId).find(item => {
                this.item = item[0];
                this.dialog = true;
            });
        }
    }

}
